//--------------------------------------------------------------------
//
//  init
//
//--------------------------------------------------------------------

// viewpoint
var VIEWPOINT = 880;


// 2015.12 画像サイズ変更改修
// カタログサイズ縦横サイズ(約分不可)
//var CATALOG_RATIO = [ 1900,1500 ];
var CATALOG_RATIO = [ 2121, 1500 ];



//--------------------------------------------------------------------
//
//  global variables
//
//--------------------------------------------------------------------

// カタログリスト
var catalogListNumbers = new Object;

// ソートされたカタログリスト
var catalogListSortNumbers = new Array;

// 選択されたカタログ情報
var catalogDetails = new Object;

// 選択されたカタログ全ページデータ
var catalogAllPages = new Object;

// 選択されたカタログの表示されるページデータ
var catalogPages = new Object;

// カタログ全アイテムデータ
var catalogAllItems = new Object;

// お気に入りページのJson上のpage_no
var favoritePage = new Array;

// 現在のカタログナンバー
var currentCatalog = 0;

// 現在のページナンバー
var currentPage = 0;

// 現在のカタログIndex
var currentCatalogIndex = new Object;

// 現在のカタログアイテムデータ
var currentItems = new Array;

// カタログページ数
var totalPages = 0;

// 旧デジカタへのリンクbook番号
var old_digicata = [ "1161", "1162", "1166", "1171", "1168", "1167", "1169", "1170", "1164", "1165", "1173", "1174", "1172", "1175", "1176" ];




//--------------------------------------------------------------------
//
//  Onload & Resize
//
//--------------------------------------------------------------------

// 日付の取得
var now = new Date();
var	nYear = now.getFullYear();
var	nMonth = now.getMonth() + 1;
var	nDate = now.getDate();

now = nMonth;
if( nMonth < 10 ) now = "0" + String( nMonth );

now = ( nDate < 10 ) ? String( now ) + "0" + String( nDate ) : String( now ) + String( nDate );
now = String( nYear ) + now;


// 便利変数
var d = document;
function byID( e ){ return d.getElementById( e ); }

// window width
var WINDOW_W = $( window ).width();

// JSONファイル読込フラグ
var Pageflag = false;
var Itemflag = false;

// zoom flag
var ZOOMIN = 0;

// user agent
var UA = navigator.userAgent;
var isIE7 = UA.match(/msie [7.]/i);
var isIE8 = UA.match(/msie [8.]/i);
var isIE9 = UA.match(/msie [9.]/i);
var isAndroid = UA.match(/Android/i);
var isIpad = UA.match(/iPad/i);


// 2014.10.09 modified START ///////////////////////////////////////////////////////////////////////////
// @author sasaki
// DOM読み込んでからの処理に変更。

// Window Onload
$(document).ready(function(){
//$(function() {

	// loading
	$( 'head' ).append( '<style type="text/css">#container { display: none; } #fade, #loader { display: block; }</style>' );

	// カタログインデックスの読み込み
	$.ajax({
		url			:"https://testr6b1.myshopify.com/cdn/shop/t/44/assets/d-catalog.js",
		type		:"GET",
		async		:false,
		dataType	:"json",
		timeout		:10000,	
		success		:function( data ) {
			try {

				// 表示期間内のカタログのみ
				var from, to;

				for( var i in data.catalog ) { 
		
					from = data.catalog[i].book_effective_dt_from;
					to = data.catalog[i].book_effective_dt_to;

//CMSの影響で、fromは無視。 2014.5.8 oguri@quad
//					if( now <= to && now >= from )
					if( now <= to ) catalogListNumbers[i] = data.catalog[i];
					
				}

				for( var i = 0, len = data.sort.length; i < len; i++ ) {
					catalogListSortNumbers[i] = data.sort[i];
					for( var ii = 0, len2 = catalogListSortNumbers[i].view_sort.length; ii < len2; ii++ ) {
					
						for( var iii in catalogListNumbers ) {
							if( catalogListSortNumbers[i].view_sort[ii] == iii ) {
								catalogListSortNumbers[i].view_sort[ii] = catalogListNumbers[iii]
								catalogListSortNumbers[i].view_sort[ii].no = iii;
							} 
						}
					}
				}

			} catch( e ) {
				console.log( e );
				$( "#center_area" ).prepend( "<p class='error'>カタログデータの読み込み中にエラーが発生しました。ページを再読み込みしてください。</p>" );
				$( "#container" ).css( "display", "block" );
				$( "#loader" ).fadeOut( 300 );
			}
		},
		error		:function( xmlHttpRequest, textStatus, errorThrown ) {
			console.log( xmlHttpRequest, textStatus );
			$( "#center_area" ).prepend( "<p class='error'>カタログデータ（catalog.js）の読み込みに失敗しました。ネットワーク接続を確認するか、しばらくしてから再度お試しください。</p>" );
			$( "#container" ).css( "display", "block" );
			$( "#loader" ).fadeOut( 300 );
		}
	});

	var str = window.location.search.substring( 1 );

	if( str ) {

		var urlValue = str.split( "&" ),
			number = {};

		for( var i = 0, len = urlValue.length; i < len; i++ ) {
			var split = urlValue[i].split( "=" );
			number[ split[0] ] = split[1];
		}

		currentCatalog = ( 'catalog' in number && number[ 'catalog' ] ) ? number[ 'catalog' ] : 99999;        

		if( currentCatalog.length == 4 ) {

			for( var i in catalogListNumbers[ currentCatalog ] ){ catalogDetails[i] = catalogListNumbers[ currentCatalog ][i]; }

			// Catalog page data
			$.ajax({
				url			:"https://testr6b1.myshopify.com/cdn/shop/t/44/assets/" + currentCatalog + "_page.js",
				type		:"GET",
				async		:false,
				dataType	:"json",
				timeout		:10000,	
				success		:function( data ) {

					try {

						for( var i in data.page ) { catalogAllPages[i] = data.page[i]; }	

						// カタログ名
						byID( "catalog_name" ).getElementsByTagName( "p" )[0].innerHTML = catalogDetails.book_name;
						$( "#name_wrapper" ).css( "display", "block" );

						// Catalog item data
						$.ajax({
							url			:"https://testr6b1.myshopify.com/cdn/shop/t/44/assets/" + currentCatalog + "_item.js",
							type		:"GET",
							async		:false,
							dataType	:"json",
							timeout		:10000,
							success		:function( data ) {

								try {

									$( "#page_number_wrapper" ).css( "opacity", "1" );
									for( var i in data.item ) { catalogAllItems[i] = data.item[i]; }

									Itemflag = true;

								} catch( e ) {
									console.log( e );
									console.log( "System Error : " + currentCatalog + "_item.js" );
								}

							},
							error		:function( xmlHttpRequest, textStatus, errorThrown ) {
								console.log( xmlHttpRequest, textStatus );
								console.log( "System Error : " + currentCatalog + "_item.js" );
								alert( "選択されたカタログのアイテムデータがありません" );
							}
						});

						Pageflag = true;

					} catch( e ) {
						console.log( e );
						console.log( "System Error : " + currentCatalog + "_page.js" );
					}

				},
				error		:function( xmlHttpRequest, textStatus, errorThrown ) {
					console.log( xmlHttpRequest, textStatus );
					console.log( "System Error : " + currentCatalog + "_page.js" );
					$( "#center_area" ).prepend( "<p class='error'>選択されたカタログのページデータがありません</p>" );
				}
			});

			if( Pageflag ) {

				// 表示期間内のページ情報のみ
				var pageCnt = 0;
				var from, to;

				for( var i in catalogAllPages ) {
	
					from = catalogAllPages[i].page_effective_dt_from;
					to = catalogAllPages[i].page_effective_dt_to;

//CMSの影響で、fromは無視。 2014.5.8 oguri@quad
//					if( now <= to && now >= from ) {
					if( now <= to ) {
						catalogPages[ pageCnt ] = catalogAllPages[ i ];
						pageCnt++;
					}

				}

				totalPages = count( catalogPages ) - 1;

				// cookieの取得
				if ( navigator.cookieEnabled ) { if ( d.cookie ) var cookieObj = getCookies(); }

				// クエリにページが指定されているか、クッキーに残っている場合表示ページを移動
				if( number.page ) {
					for( var i in catalogPages ) {
						if( number.page == String( catalogPages[i].page_no ) ) {
							currentPage = i;
							setTimeout(function(){ sliderSlide(); }, 900);
							break;
						}
					}
				} else if( cookieObj ) {
					if( cookieObj[ "M" + currentCatalog ] ) {
						for( var i in catalogPages ) {
							if( cookieObj[ "M" + currentCatalog ] == String( catalogPages[i].page_no ) ) {
								currentPage = i;		
								setTimeout(function(){ sliderSlide(); }, 900);
								break;
							}
						}
					} else {
						currentPage = 0;
						setTimeout(function(){ sliderSlide(); }, 900);
					}
				}

				$.event.add( window, "load", function() {

				    var pageH = $( "#container" ).height();

				    $( "#fade" ).css( "height", pageH + 1000 ).delay( 1100 ).fadeOut( 800 );
				    $( "#loader" ).delay( 600 ).fadeOut( 300 );
				    $( "#container" ).css( "display", "block" );

				    setPages( currentPage );
					checkFavoritePage();
					setTimeout(function(){ ( WINDOW_W > VIEWPOINT ) ? pc_btnAnimate() : sp_btnAnimate(); }, 1000);
					
					$( "#next" ).css( "right", "274px" );
	
					// slideToggle event
					if( WINDOW_W <= VIEWPOINT ) {
						$( ".toggle_btn" ).on( "click", function() {
							$(this).parent().parent().next().slideToggle( 200, function(){ setToggleBtn( this ); });
						});
					}

					
					// *** Add start Catalogue Index *** //

					var listHTML = "",
						indexNum = 0,
						indexRowWidth = 0,
						nonThemeFlag = false,
						nonCnt = 0,
						name;
	
					for( var i in catalogPages ) {
	
						if( catalogPages[i].page_theme in currentCatalogIndex || nonThemeFlag ) {
						
							if( catalogPages[i].page_theme !== "" ) {
								
								if( nonThemeFlag ) {

									name = catalogPages[i].page_theme;
									currentCatalogIndex[ name ] = [];
									currentCatalogIndex[ name ][0] = catalogPages[i];
									
									nonThemeFlag = false;
									nonCnt++;
									
								} else {
								
									name = catalogPages[i].page_theme;
									currentCatalogIndex[ name ].push( catalogPages[i] );
								
								}
	
							} else {
	
								name = "nNn" + nonCnt;
								currentCatalogIndex[ name ].push( catalogPages[i] );
	
							}
	
						} else {
						
							name = ( catalogPages[i].page_theme === "" ) ? "nNn" + nonCnt : catalogPages[i].page_theme;
	
							currentCatalogIndex[ name ] = [];
							currentCatalogIndex[ name ][0] = catalogPages[i];
	
							nonThemeFlag = ( catalogPages[i].page_theme === "" ) ? true : false;
	
						}
	
					}
					
					var cnt = 0;
	
					for ( var i in currentCatalogIndex ) {
	
						var listLi = "",
							indexpageNum = 0,
							txt;
	
						indexNum = count( currentCatalogIndex[i] );
	
						if( indexNum > indexRowWidth  ) indexRowWidth = indexNum;
	
						for( var j = 0; j < indexNum; j++ ) {
							if( currentCatalogIndex[i][j] ) {
								indexpageNum = String( currentCatalogIndex[i][j].page_no );
								listLi += "<li class='theme_img'><img class='close' src='" + "." + currentCatalogIndex[i][j].small_img + "' ><p class='popup_hidden'>" + indexpageNum + "</p></li>";
							}
						}
	
						
						var theme = ( i.search( "nNn" ) !== 0 ) ? "<span>" + i + "</span>" : "<span class='index_hide'>" + i + "</span>";
	
						
						listHTML += ( indexNum <= 4 )
							? "<div id='LI" + cnt + "' class='popup-index_thumbnail'><ul class='row_image_area'><li class='index_left'></li><li class='index_center'><ul class='row_wrapper'>" + listLi + "</ul></li><li class='index_right'></li></ul><p class='popup_text4'>" + theme + "（P" + currentCatalogIndex[i][0].page_no + "～)</p></div>"
							: "<div id='LI" + cnt + "' class='popup-index_thumbnail'><ul class='row_image_area'><li class='index_left'><img src='./d_images/btn-index_previous@2x.gif'></li><li class='index_center'><ul class='row_wrapper'>" + listLi + "</ul></li><li class='index_right'><img src='./d_images/btn-index_next@2x.gif'></li></ul><p class='popup_text4'>" + theme + "（P" + currentCatalogIndex[i][0].page_no + "～)</p></div>";
						
						if( i.search( "nNn" ) !== 0 ) {
							$( "#index_list" ).append( $( "<option>" ).html( i + "（P" + currentCatalogIndex[i][0].page_no + "～)" ).val( "LI" + cnt ) );
						}
						
						cnt++;
	
					}
	
					$( "#leftP img, #rightP img" ).error(function(){ defaultImg( this, 'page' ); });
	
					byID( "popup-index_thumbnail_wrapper" ).innerHTML = listHTML;

					$( ".theme_img img" ).error(function(){ defaultImg( this, 'thumb' ); });
					
					if( !isIE7 && !isIE8 ) {
						$( "#index_list" ).customSelect();
						$( "#popup-index_list .customSelect" ).css( "marginTop", "0" );
					}
					
					$( "#index_list" ).css({ visibility: "visible", marginTop: "-15px" });
					$( ".row_wrapper" ).css({ marginLeft: "0", width: indexRowWidth * 174 + "px" });
					
					
					// ページ一覧内 nextボタン
					$( "#popup-index_thumbnail_wrapper" ).on( "click", ".index_right", function(){
						$( "#popup-index_thumbnail_wrapper" ).off( "click" );
						setIndexNext( this );
					});
					
					// ページ一覧内 prevボタン
					$( "#popup-index_thumbnail_wrapper" ).on( "click", ".index_left", function(){
						$( "#popup-index_thumbnail_wrapper" ).off( "click" );
						setIndexPrev( this );
					});

					// ページ一覧内 select
					$( "#popup-index_list" ).on( "click", "#index_list", function(){
						
					});

					$( "#popup-index_list" ).on( "change", "#index_list", function(){
						var sel = $( this ).val();
						var topNum = ( WINDOW_W <= VIEWPOINT ) ? $( "#" + sel )[0].offsetTop - 120 : $( "#" + sel )[0].offsetTop - 100;

						setTimeout(function(){
							$( "#popup-index_thumbnail_wrapper" ).stop().animate({ scrollTop: topNum }, "linear");							
						}, 50);
						
						return false;

					});
					
					// *** Add end Catalogue Index *** //

				});

				var thumb_path = "." + catalogPages[0].small_img,
					page_theme = catalogPages[0].page_theme,
					page_no = catalogPages[0].page_no;
			
				byID( "pc-page_slider_thumb" ).getElementsByTagName( "div" )[0].innerHTML = page_no;
				byID( "pc-page_slider_thumb" ).getElementsByTagName( "p" )[0].innerHTML = page_theme;
				byID( "pc-page_slider_thumb" ).getElementsByTagName( "img" )[0].src = thumb_path;

			}


			//--------------------------------------------------------------------
			//
			//  Events
			//
			//--------------------------------------------------------------------

			// テンキースクロールOFF
			$( window ).keydown(function( e ) {
			    var code = e.keyCode;
				if( code >= 37 && code <= 40 ){
					if ( e.preventDefault ) e.preventDefault();
				}
			});

			$( "#footer_contents" ).on( {
				'mouseenter' : function(){ $(this).attr( "src", $(this).attr( "src" ).replace( ".up", ".over" ))},
				'mouseleave' : function(){ $(this).attr( "src", $(this).attr( "src" ).replace( ".over", ".up" ))}
			}, 'img' );

			$( "#main" ).on( {
				'mouseenter' : function(){ $(this).stop().animate({ marginRight: "-5px" }, 100)},
				'mouseleave' : function(){ $(this).stop().animate({ marginRight: "-20px" }, 100)}
			}, '#next' );

			$( "#main" ).on( {
				'mouseenter' : function(){ $(this).stop().animate({ marginLeft: "-5px" }, 100)},
				'mouseleave' : function(){ $(this).stop().animate({ marginLeft: "-20px" }, 100)}
			}, '#previous' );


			$( ".popup_container" ).on( "click", ".close", function(){ $(".lb_overlay").remove(); } );
			
			$( ".popup-close img" ).on({
				'mouseover' : function(){$( this ).attr( "src", $( this ).attr( "src" ).replace( "close", "close2" ))},
				'mouseout' : function(){$( this ).attr( "src", $( this ).attr( "src" ).replace( "close2", "close" ))}
			});
			
			$( "#name_wrapper" ).on( "click", "#catalog_name", function(){ 
				firstPosition();
				ZOOMIN = 0;
				turnPages( 0 );
			});

			// 次ページボタン
// 2015.12 左開き対応
//			$( "#next" ).bind( "click", function(){ setNextPage(); scaleDown(); });
			$( "#next" ).bind( "click", function(){ setPreviousPage(); scaleDown(); });

			// 前ページボタン
// 2015.12 左開き対応
//			$( "#previous" ).bind( "click", function(){ setPreviousPage(); scaleDown(); });
			$( "#previous" ).bind( "click", function(){ setNextPage(); scaleDown(); });

			// 拡大ボタン
			$( "#footer_nav" ).on( "click", "#btn-scale_up", function(){
				
				var X = $( window ).width() / 2,
					Y = $( window ).height() / 2;
				zoomAction( X, Y );
			});

			// 縮小ボタン
			$( "#footer_nav" ).on( "click", "#btn-scale_down", function(){
				
				if( ZOOMIN >= 2 ) {
					ZOOMIN = 1;
				} else {
					ZOOMIN = 0;
				}
				var X = $( window ).width() / 2,
					Y = $( window ).height() / 2;
				zoomPosition( X, Y );
				
			});

			// 元のサイズに戻すボタン
			$( "#footer_nav" ).on( "click", "#btn-scale_actual", function(){
				
				firstPosition();
						
			});

			// ページスライダー
			$('#pc-page_slider').slider({
				min: 0,
				max: totalPages,
				value: 0,
				step: 1,
				animate: "fast",
				slide: function( event, ui ){

					// 2016.02 左開き対応 スライダー
					//var page = ui.value,
					var page = totalPages - ui.value,
						thumb_path = "." + catalogPages[ page ].small_img,
						page_theme = catalogPages[ page ].page_theme,
						page_no = catalogPages[ page ].page_no;

					byID( "pc-page_slider_thumb" ).getElementsByTagName( "div" )[0].innerHTML = page_no;
					byID( "pc-page_slider_thumb" ).getElementsByTagName( "p" )[0].innerHTML = page_theme;
					byID( "pc-page_slider_thumb" ).getElementsByTagName( "img" )[0].src = thumb_path;

					var num = 100 / totalPages;
					num = num * ( ui.value + 1 ) - num - 6.2;

					$( "#pc-page_slider_thumb" ).css( "left", num + "%" );
				},
				change: function( event, ui ){
					
					// 2016.02 左開き対応 スライダー
					//currentPage = ui.value;
					currentPage = totalPages - ui.value;
					setPages( currentPage );
					checkFavoritePage();
// 2015.12 左開き対応
					setTimeout(function(){ pc_btnAnimate(); }, 500); 
//					setTimeout(function(){ pc_btnAnimate(); }, 1000); 
					scaleDown();
					firstPosition();
					ZOOMIN = 0;
				}
			});

			// ページスライダーサムネイル表示アニメーション
			var timer2;
			$( "#pc-page_slider" ).on({
				"mouseover": function(){
					clearTimeout( timer2 );
					$( "#pc-page_slider_thumb" ).css( "display", "block" ).stop().animate({ opacity:"1" }, 200);
				},
				"mouseout": function(){
					clearTimeout( timer2 );
					timer2 = setTimeout( function(){
						$( "#pc-page_slider_thumb" ).stop().animate({ opacity:"0" }, 300);
						setTimeout( function(){ $( "#pc-page_slider_thumb" ).css( "display", "none" ); }, 300 )
					}, 1000 )
				}
			}, ".ui-slider-handle" );


			// お気に入りボタン
			$( "#footer_nav" ).on( "click", "#btn-favorite", function(){

				if( $.inArray( String( catalogPages[ currentPage ].page_no ), favoritePage ) == -1 ) {
					//お気に入りに登録
					
					favoritePage.push( String( catalogPages[ currentPage ].page_no ) );		
					
					var src = byID( "btn-favorite" ).childNodes[0].src.replace( ".over", ".selected" ).replace( ".up", ".selected" );
					byID( "btn-favorite" ).childNodes[0].src = src;
					var src2 = byID( "btn-favorite" ).childNodes[1].src.replace( ".over", ".selected" ).replace( ".up", ".selected" );
					byID( "btn-favorite" ).childNodes[1].src = src2;

				} else {
					//お気に入りを外す

					var cnt = $.inArray( String( catalogPages[ currentPage ].page_no ), favoritePage );
					favoritePage.splice( cnt, 1 );

					var src = byID( "btn-favorite" ).childNodes[0].src.replace( ".selected", ".up" );
					byID( "btn-favorite" ).childNodes[0].src = src;

					var src2 = byID( "btn-favorite" ).childNodes[1].src.replace( ".selected", ".up" );
					byID( "btn-favorite" ).childNodes[1].src = src2;

				}

				// Cookie登録
				if ( navigator.cookieEnabled ) {

					var expire = new Date();
					expire.setTime( expire.getTime() + 1000 * 3600 * 24 * 180 );

					var cookies = getCookies();
					for( var i in cookies ) {
						if( i == currentCatalog ) {
							var delExpire = new Date();
							delExpire.setTime( delExpire.getTime() / 10 + 1000 * 3600 * 24 );
							var delCookie = i + "=" + cookies[i];
							d.cookie = delCookie;
							break;
						}
					}

					d.cookie = ( favoritePage.length > 0 )
						? currentCatalog + "=" + encodeURIComponent( favoritePage ) + "; expires=" + expire.toUTCString()
						: currentCatalog + "=" + "null" + "; expires=" + expire.toUTCString();
				}

				// お気に入りポップアップ要素作成
				var favoriteHTML = ( otherBookFavoritesHTML ) ? otherBookFavoritesHTML : "";
				var	img_path, book_text, page_no;
				var f_group = catalogListNumbers[ currentCatalog ].book_group;
				var f_name = catalogListNumbers[ currentCatalog ].book_name;
				
				for( var i = 0, len = favoritePage.length; i < len; i++ ) {
					for( var j in catalogPages ) {
						if( String( catalogPages[j].page_no ) == favoritePage[i] ) {

							img_path = "." + catalogPages[j].small_img;
							book_text = catalogPages[j].page_theme;
							page_no = String( catalogPages[j].page_no );

							favoriteHTML += '<li><span class="theme_close"><img class="retina" src="./d_images/theme_close.png"></span><span class="theme_img"><img class="close" src="' + img_path + '" alt=""></span><p class="popup_group">' + f_group + '</p><p class="popup_name">' + f_name + '</p><p class="popup_text3">' + book_text + '(<span>P' + page_no + '</span>～)</p><p class="popup_hidden">' + currentCatalog + '</p></li>';

							break;
						} 
					}
				}

				byID( "popup-favorite_thumbnail" ).innerHTML = favoriteHTML;
				$( ".theme_img img" ).error(function(){ defaultImg( this, 'thumb' ); });

			});


			// 商品一覧ボタン
			$( "#container" ).on( {
				'mouseenter' : function(){ $( "#list_btn" ).stop().animate({ right: "0px" }, 100)},
				'mouseleave' : function(){ $( "#list_btn" ).stop().animate({ right: "-20px" }, 100)},
				'click' : function(){
					$( this ).attr( "src", $( this ).attr( "src" ).replace( ".open.", ".close." ));
					$("#list_btn").removeClass("side_close").addClass("side_open");

					$( "#product_list_wrapper" ).css( "display", "block" ).stop().animate( { right: "0px" }, 200 );
					$( "#list_btn" ).stop().animate( { right: "274px" }, 200 );
// 2015.12 左開き改修
//					if( currentPage != totalPages ) $( "#next" ).stop().animate( { right: "274px" }, 200 );
					if( currentPage != 0 ) $( "#next" ).stop().animate( { right: "274px" }, 200 );
					
					var ww = WINDOW_W - 274;
					if((WINDOW_W / 2) - 274  < 440) $("#footer").stop().animate({width:ww + "px"},100);
				}
			}, '#list_btn img[src="./d_images/btn-product_list.open.png"]' );

			if( !isIpad ) {
				$( "#list_btn" ).on({
					'mouseover' : function(){$( "#list_btn img" ).attr( "src", $( "#list_btn img" ).attr( "src" ).replace( ".close.", ".close2." ))},
					'mouseout' : function(){$( "#list_btn img" ).attr( "src", $( "#list_btn img" ).attr( "src" ).replace( ".close2.", ".close." ))}
				});
				
				$( "#list_btn" ).on( "click", "img[src='./d_images/btn-product_list.close2.png']", function(){
					
					var self = this;
					$("#list_btn").removeClass("side_open").addClass("side_close");
					
					$( "#product_list_wrapper" ).stop().animate( { right: "-274px" }, 200 );
					$( "#list_btn" ).stop().animate( { right: "-20px" }, 200 );

// 2015.12 左開き改修
//					if( currentPage != totalPages ) $( "#next" ).stop().animate( { right: "0px" }, 200 );
					if( currentPage != 0 ) $( "#next" ).stop().animate( { right: "0px" }, 200 );
					
					
					setTimeout(function(){
						$( "#product_list_wrapper" ).css( "display", "none" );
						$( self ).attr( "src", $( self ).attr( "src" ).replace( ".close2.", ".open." ).replace( ".close.", ".open." ));
					}, 200);
					if($("#footer").css("width") != "100%") $("#footer").stop().animate({width:"100%"},100);
				});
			} else {
				
				$( "#list_btn" ).on( "click", "img[src='./d_images/btn-product_list.close.png']", function(){
					
					var self = this;
					$("#list_btn").removeClass("side_open").addClass("side_close");
					
					$( "#product_list_wrapper" ).stop().animate( { right: "-274px" }, 200 );
					$( "#list_btn" ).stop().animate( { right: "-20px" }, 200 );

// 2015.12 左開き改修
//					if( currentPage != totalPages ) $( "#next" ).stop().animate( { right: "0px" }, 200 );
					if( currentPage != 0 ) $( "#next" ).stop().animate( { right: "0px" }, 200 );
					
					setTimeout(function(){
						$( "#product_list_wrapper" ).css( "display", "none" );
						$( self ).attr( "src", $( self ).attr( "src" ).replace( ".close2.", ".open." ).replace( ".close.", ".open." ));
					}, 200);
					if($("#footer").css("width") != "100%") $("#footer").stop().animate({width:"100%"},100);
				});
			}


			// サイズと色による値段表記変更と、それぞれに対応したサイズと色の種類を表示
			$( "#product_contents" ).on( "change", ".pd_color, .pd_size", function(){

				var sel_num = $( this ).parents()[5].childNodes[0].childNodes[1].childNodes[3].childNodes[1].innerHTML,
					sel_size = $( this ).parents()[3].childNodes[0].childNodes[1].childNodes[1].childNodes[0].value,
					sel_color = $( this ).parents()[3].childNodes[0].childNodes[0].childNodes[1].childNodes[0].value;

				var sel = $( this ).parents()[3].childNodes[0].childNodes[1].childNodes[1].childNodes[0],
					selOption = sel.getElementsByTagName( "option" )[0];

				var colorSelect = false;
				colorSelect = ( $( this )[0].className.search( "pd_color" ) > -1 ) ? true : false;

				var sku = [],
					size_options = '<option value="">選択してください</option>',
					sel_price, list_size, list_color, pd_size, sel;

                /* modification by fushimik 20141110 start */
                var str_size_name ="";
                /* modification by fushimik 20141110 end */

				for( var i in currentItems ) {
					if( currentItems[i].no == sel_num ){

						// 商品価格の初期値
						var priceArray = currentItems[i].sku[0].p.split( "," );
						sel_price = priceArray[4];

						for( var ii = 0, len = currentItems[i].sku.length; ii < len; ii++ ) {

						 	sku = currentItems[i].sku[ii].p.split( "," );
							list_size = sku[0];
							list_color = sku[2];
                            /* modification by fushimik 20141110 start */
                            list_size_name = sku[1];
                            
                            str_size_name = list_size_name ? " = " + list_size_name : ""; 
                            if( list_color == sel_color && colorSelect ) size_options += '<option value="' + list_size + '">' + list_size + str_size_name + '</option>';
                            str_size_name ="";
                            /* modification by fushimik 20141110 end */
							if( list_size == sel_size && list_color == sel_color ) sel_price = sku[4];

						};

						if( colorSelect && sel_color ) {

							if( !isIE7 && !isIE8 && !isIE9 ) sel.innerHTML = size_options;

							for( var ii = 0, len = sel.options.length; ii < len; ii++ ) {

								if( sel.options[ii].value != sel_size ) {

									selOption.selected = true;

									// customSelectに表示
									if( !isIE7 && !isIE8 ) $( this ).parents()[3].getElementsByTagName("span")[3].innerHTML = selOption.innerHTML;

								} else {

									sel.getElementsByTagName( "option" )[ii].selected = true;

									// customSelectに表示
									if( !isIE7 && !isIE8 ) {
										selOption = sel.getElementsByTagName( "option" )[ii];
										$( this ).parents()[3].getElementsByTagName("span")[3].innerHTML = selOption.innerHTML;
									}
									break;
								
								}
							}

						} else if( colorSelect ) {

							var full_size = [];
                            /* modification by fushimik 20141110 start */
                            var size_name = [];
							for( var ii in currentItems[i].sku ) {
								sku = currentItems[i].sku[ii].p.split( "," );
								if( $.inArray( sku[0], full_size ) == -1 ) full_size.push( sku[0] );
                                if( $.inArray( sku[1], size_name ) == -1 ) size_name.push( sku[1] );
							}

                            size_name[0] = sku[1];
							for( var iii = 0, len2 = full_size.length; iii < len2; iii++ ) {
                                str_size_name = (size_name[iii]) ? " = " + size_name[iii] : ""; 
                                size_options += '<option value="' + full_size[iii] + '">' + full_size[iii] + str_size_name + '</option>';
                                str_size_name = "";
							}
                            /* modification by fushimik 20141110 end */
							if( !isIE7 && !isIE8 && !isIE9 ) sel.innerHTML = size_options;

							for( var ii = 0, len = sel.options.length; ii < len; ii++ ) {

								if( sel.options[ii].value != sel_size ) {
									selOption.selected = true;

									// customSelectに表示
									if( !isIE7 && !isIE8 ) $( this ).parents()[3].getElementsByTagName("span")[3].innerHTML = selOption.innerHTML;

								} else {
									sel.getElementsByTagName( "option" )[ii].selected = true;

									// customSelectに表示
									if( !isIE7 && !isIE8 ) {
										selOption = sel.getElementsByTagName( "option" )[ii];
										$( this ).parents()[3].getElementsByTagName("span")[3].innerHTML = selOption.innerHTML;
									}
									break;
								}
							}
						}

						$( this ).parents()[5].childNodes[0].childNodes[1].childNodes[2].childNodes[1].innerHTML = "￥" + getComma( sel_price );
						break;

					}
				};
			});
			

		} else {
			$( "#center_area" ).prepend( "<p class='error'>カタログナンバーが存在しないか間違っている為、カタログが表示できません。<br>カタログを選択し直してください。</p>" );
		}
	} else {
		$( "#center_area" ).prepend( "<p class='error'>画面上部の【 他のカタログを見る 】メニューから、カタログを選択してください。</p>" );
	}
	
	$( "#container" ).css( "display", "block" ).delay( 600 ).stop().animate({ opacity: 1 }, 300 );

	// cookieからお気に入りページ作成	
	if ( navigator.cookieEnabled ) {
		if ( d.cookie ) {

			if( cookieObj ) var cookieObj = getCookies();		

			var	otherBookFavoritesHTML = "",
				currentFavoritesHTML = "";

			if( catalogListNumbers[ currentCatalog ] ) {
				var f_group = catalogListNumbers[ currentCatalog ].book_group,
					f_name = catalogListNumbers[ currentCatalog ].book_name;
			}

			for( var i in cookieObj ) {

				if( currentCatalog == i ) {

					if( cookieObj[i] != null ) {
						favoritePage = cookieObj[i].split( "," );				
						for( var j = 0, len = favoritePage.length; j < len; j++ ) favoritePage[j] = String( favoritePage[j] );
					}


					for( var ii = 0, len2 = favoritePage.length; ii < len2; ii++ ) {
						for( var jj in catalogPages ) {
							if( String( catalogPages[jj].page_no ) == favoritePage[ii] ) {

								var img_path = "." + catalogPages[jj].small_img,
									book_text = catalogPages[jj].page_theme,
									page_no = String( catalogPages[jj].page_no );

								currentFavoritesHTML += '<li><span class="theme_close"><img class="retina" src="./d_images/theme_close.png"></span><span class="theme_img"><img class="close" src="' + img_path + '" alt=""></span><p class="popup_group">' + f_group + '</p><p class="popup_name">' + f_name + '</p><p class="popup_text3">' + book_text + '（<span>P' + page_no + '</span>～）</p><p class="popup_hidden">' + i + '</p></li>';

								break;
							} 
						}
					}

					checkFavoritePage();


				} else {

					if( cookieObj[i] != null && !i.match(/[A-Za-z]/g) && i.length <= 4 ) {

						var otherBookFavoritePage = cookieObj[i].split(",");

						/* modification by fushimik 20141030 start*/
						if (catalogListNumbers[ i ] != undefined){
						
							var f_group = catalogListNumbers[ i ].book_group;
							var f_name = catalogListNumbers[ i ].book_name;	

							$.ajax({
								url			:"https://www.nissen.co.jp/d_catalog/app/json/" + i + "_page.js",
								type		:"GET",
								async		:false,
								dataType	:"json",
								timeout		:10000,	
								success		:function( data ) {
	
									try {
	
										for( var jj = 0, len = data.page.length; jj < len; jj++ ) {
											for( var jjj = 0, len2 = otherBookFavoritePage.length; jjj < len2; jjj++ ) {
												if( String( data.page[jj].page_no ) == otherBookFavoritePage[jjj] ) {
	
													img_path = "." + data.page[jj].small_img;
													book_text = data.page[jj].page_theme;
													page_no = String( data.page[jj].page_no );
	
													otherBookFavoritesHTML += '<li><span class="theme_close"><img class="retina" src="./d_images/theme_close.png"></span><span class="theme_img"><img class="close" src="' + img_path + '" alt=""></span><p class="popup_group">' + f_group + '</p><p class="popup_name">' + f_name + '</p><p class="popup_text3">' + book_text + '（<span>' + page_no + '</span>～）</p><p class="popup_hidden">' + i + '</p></li>';
																					
													break;
	
												}
											}
										}
	
										byID( "popup-favorite_thumbnail" ).innerHTML = otherBookFavoritesHTML;
										
									} catch( e ) {
										console.log( e );
										console.log( "System Error : " + i + "_page.js" );
									}
	
								},
								error		:function( xmlHttpRequest, textStatus, errorThrown ) {
									console.log( xmlHttpRequest, textStatus );
									console.log( "System Error : " + i + "_page.js" );
								}
							});

						}else{
							/* 掲載期間の過ぎたCookieを削除 */
							var dTime = new Date();
							dTime.setYear(dTime.getYear() - 1);
							document.cookie = i + "=;expires=" + dTime.toGMTString();
						}
						/* modification by fushimik 20141030 end*/
					}
				}
			}

			byID( "popup-favorite_thumbnail" ).innerHTML += currentFavoritesHTML;
			$( ".theme_img img" ).error(function(){ defaultImg( this, 'thumb' ); });

		}

	} else {
		alert("ブラウザの設定にてCookieの受け入れを有効にすると、全カタログのお気に入り登録ページが保持されます。");
	}


	if( !Pageflag ) { $.event.add( window, "load", function() {
		    var pageH = $( "#container" ).height();	
		    $( "#fade" ).css( "height", pageH + 1000 ).delay( 900 ).fadeOut( 800 );
		    $( "#loader" ).delay( 600 ).fadeOut( 300 );
		    $( "#container" ).css( "display", "block" );
		});
	}

	// 他のカタログポップアップ要素作成
	var otherHTML = "",
		obj, book_img, book_name, book_text;

	for( var i = 0, len = catalogListSortNumbers.length; i < len; i++ ) {
		
		otherHTML += ' <ul class="popup-other_group"><p class="popup-other_group_name">' + catalogListSortNumbers[i].view_group + '</p>';

		for( var ii = 0, len2 = catalogListSortNumbers[i].view_sort.length; ii < len2; ii++ ) {
			
			if( typeof catalogListSortNumbers[i].view_sort[ii] !== "string" ) {
				
				obj = catalogListSortNumbers[i].view_sort[ii];
				
				book_img = "." + obj.book_img;
				book_name = obj.book_name;
				book_text = obj.book_text;
			
				if( $.inArray( obj.no, old_digicata ) == -1  && currentCatalog != obj.no ) {
					otherHTML += '<li><a href="index.html?catalog=' + obj.no + '"><img src="' + book_img + '" onerror="defaultImg( this )" ><p class="popup_text1">' + book_name + '</p><p class="popup_text2">' + book_text + '</p></a></li>';
				} else if( currentCatalog != obj.no ) {
					otherHTML += '<li><a href="javascript:void(0);" onClick="javascript:DcNolWinOpen(&quot;' + obj.no + '&quot;,&quot;&quot;,&quot;&quot;,&quot;2&quot;)"><img src="' + book_img + '" onerror="defaultImg( this )" ><p class="popup_text1">' + book_name + '</p><p class="popup_text2">' + book_text + '</p></a></li>';
				}
			
			}

		}

		otherHTML += '</ul>';

	}

	$( "#popup-other_thumbnail" )[0].innerHTML = otherHTML;

	
	// カタログの使い方ポップアップ
	var guide = $( "#guide_list" );
	guide.append( $( "<option>" ).html( "ボタン操作について" ).val( 1 ) );
	guide.append( $( "<option>" ).html( "お気に入りページについて" ).val( 2 ) );
	guide.append( $( "<option>" ).html( "他のカタログについて" ).val( 3 ) );
	guide.append( $( "<option>" ).html( "カタログのページ一覧について" ).val( 4 ) );	
	guide.css({ visibility: "visible", marginTop: "-15px" });

	if( !isIE7 && !isIE8 ) {
		guide.customSelect();
		$( "#popup-guide_list .customSelect" ).css( "marginTop", "0" );
	}else{
		( WINDOW_W > VIEWPOINT )
			? $( "#popup-guide_wrapper" ).css( "height", "452px" )
			: $( "#popup-guide_wrapper" ).css( "height", "352px" );
	}
	
	$( "#pc_menu, #sp_menu" ).on( {
		'mouseenter' : function(){ $(this).attr( "src", $(this).attr( "src" ).replace( ".up", ".over" ))},
		'mouseleave' : function(){ $(this).attr( "src", $(this).attr( "src" ).replace( ".over", ".up" ))}
	}, 'img' );

	
	// Retina
	if ( window.devicePixelRatio > 1 ) {
		$( 'img.retina' ).each( function() {
			var imgExt = this.src.substr( -4 );
			var imgName = this.src.substr( 0, this.src.length - 4 );
			imgName += '@2x' + imgExt;                               
			$( this ).attr( 'src',imgName );
		});
	}

    // 2014.10.09 modified START ///////////////////////////////////////////////////////////////////////////
    // @author sasaki
    // window onload時に実行されるように下記の箇所を移動

    // Window Resize
    if( !isIE7 && !isIE8 ) $( window ).resize(function(){ catalogResize(); });

    if( isIE7 || isIE8 ) {
        agent();

        var _globalLock = 0;
        var _size = { w: 0, h: 0 };

        function getInnerSize() {
            return { w: document["documentElement"].innerWidth  || document["documentElement"].clientWidth,
                h: document["documentElement"].innerHeight || document["documentElement"].clientHeight };
        }

        // resize agent
        function agent() {
            function loop() {
                if ( !_globalLock++ ) {
                    var size = getInnerSize();
                    if ( _size.w !== size.w || _size.h !== size.h ) { // resized
                        _size = size; // update
                        catalogResize();
                    }
                    setTimeout(function() { _globalLock = 0; }, 0); // delay unlock
                }
                setTimeout( loop, 100 );
            }
            setTimeout( loop, 100 );
        }
    };
    // 2014.10.09 modified END ////////////////////////////////////////////////////////////////////////
    
    //数字を桁数に合わせる
    function convertNum(num, figures) {
		var str = String(num);
		while (str.length < figures) {
			str = "0"+str;
		}
		return str;
	}
	
	//フッター部分クリック
	$("#footerCObtn").click(function(){
		if($('#footer').hasClass('footer_close')){
			$('#footer').removeClass('footer_close').addClass('footer_open').stop().animate({ bottom : 0 }, 100 );
			$('#footerCObtn').animate({ bottom : '90px' }, 100 );
		}else{
			$('#footer').removeClass('footer_open').addClass('footer_close').stop().animate({ bottom : '-50px' }, 100 );
			$('#footerCObtn').animate({ bottom : '20px' }, 100 );
			
		}
	});


    
});
// 2014.10.09 modified END ////////////////////////////////////////////////////////////////////////






//--------------------------------------------------------------------
//
//  Popups
//
//--------------------------------------------------------------------

$(function(){

// 他のカタログポップアップ
$( "#header_contents" ).on( "click", ".popup-other", function( e ){
	
	if( !isIE7 && !isIE8 ) setPopupHeight( "popup-other" );
	$( "#popup-other" ).lightbox_me({ centered: true });
	e.preventDefault();
});

// ページ一覧ポップアップ
$( "#footer_contents" ).on( "click", ".popup-index", function( e ){
	
	if( !isIE7 && !isIE8 ) setPopupHeight( "popup-index" );
	$( "#popup-index" ).lightbox_me({ centered: true });
	e.preventDefault();

});

// カタログの使い方ポップアップ
$( "#header_contents" ).on( "click", ".popup-guide", function( e ){
	
	setGuide();
	if( !isIE7 && !isIE8 ) setPopupHeight( "popup-guide" );
	$( "#popup-guide" ).lightbox_me({ centered: true });
	//e.preventDefault();
});

// お気に入りページポップアップ
$( "#header_contents" ).on( "click", ".popup-favorite", function( e ){
	
	if( !isIE7 && !isIE8 ) setPopupHeight( "popup-favorite" );
	$( "#popup-favorite" ).lightbox_me({ centered: true });
	e.preventDefault();
});

// お気に入り削除
$( "#popup-favorite_thumbnail" ).on( "click", ".theme_close", function(){
	
	var page_no = $(this).next().next().next().next()[0].childNodes[1].innerHTML.slice(1),
		book = $(this).next().next().next().next().next()[0].innerHTML;

	if( currentCatalog == book ) {
		var cnt = $.inArray( page_no, favoritePage );
		favoritePage.splice( cnt, 1 );
	}

	$(this).parent().remove();
	checkFavoritePage();

	if ( navigator.cookieEnabled ) { 
		var cookieObj = getCookies();

		for( var i in cookieObj ) {	
			if( book == i ) {

				var otherfavoritePage = cookieObj[i].split( "," ),
					cnt2 = $.inArray( page_no, otherfavoritePage );
				otherfavoritePage.splice( cnt2, 1 );

				var expire = new Date();
				expire.setTime( expire.getTime() + 1000 * 3600 * 24 * 180 );

				d.cookie = ( otherfavoritePage.length > 0 )
					? i + "=" + encodeURIComponent( otherfavoritePage ) + "; expires=" + expire.toUTCString()
					: i + "=" + "null" + "; expires=" + expire.toUTCString();
			}	
		}
	}



});

// 「お気に入り」ポップアップ内ページリンク
$( "#popup-favorite_thumbnail" ).on( "click", ".theme_img", function(){

});

// 「ページ一覧」ポップアップ内ページリンク
$( "#popup-index_thumbnail_wrapper" ).on( "click", ".theme_img", function(){

});

// 「お気に入り」「ページ一覧」ポップアップ内ページリンク
$( "#popup-favorite_thumbnail, #popup-index_thumbnail_wrapper" ).on( "click", ".theme_img", function(){
	
	firstPosition();

	var id = $( this ).parent().parent()[0].id,
		num, num2, book;

	if( id.search( "favorite" ) > -1 ) {
		book = $( this ).next().next().next().next()[0].innerHTML;
		num2 = $( this ).next().next().next()[0].childNodes[1].innerHTML;

		num = num2.substr(1);

		if( book != currentCatalog ) {
			// var str = "/d_catalog/app/index.html?catalog=" + book + "&page=" + num2;
            var str = "/pages/d_catalog?catalog=" + book + "&page=" + num2;            
			window.location.href = str;
			return;	
		}

	} else {
		num = $( this )[0].childNodes[1].innerHTML;
	}

	turnPages( num );
	if( WINDOW_W <= VIEWPOINT ) $( ".pd_upper" ).next().hide();

});


// 「カタログの使い方」ポップアップ内 select link
$( "#popup-guide_list" ).on( "change", "#guide_list", function(){ setGuide(); });
$( ".link_favorite" ).click( function(){
	$( "select[name='guide_list']" ).val(2);
	if( !isIE7 && !isIE8 ) $( "#popup-guide_list .customSelectInner" )[0].innerHTML = "お気に入りページについて";
	setGuide();
});
$( "#link_other" ).click( function(){
	$( "select[name='guide_list']" ).val(3);
	if( !isIE7 && !isIE8 ) $( "#popup-guide_list .customSelectInner" )[0].innerHTML = "他のカタログについて";
	setGuide();
});
$( "#link_index" ).click( function(){
	$( "select[name='guide_list']" ).val(4);
	if( !isIE7 && !isIE8 ) $( "#popup-guide_list .customSelectInner" )[0].innerHTML = "カタログのページ一覧について";
	setGuide();
});


});

$(function() {
	// カート情報をセット
	getCartContent(function(totalAmount, totalPrice) {
		$('#pc-count_wrapper .count').text(totalAmount || 0);
		$('#pc-total_price_wrapper .price').text(totalPrice || 0);
	});
});